import { createSlice } from '@reduxjs/toolkit';
import { ReduxStatus } from '../../../../shared/types';
import { AnnouncementModel } from '../../feedItems/models/Announcement.mode';
import { resetAll } from '../../../../shared/infra/redux/baseActions';

export interface DashboardState {
  announcement: AnnouncementModel | null;
  createAnnouncementStatus: {
    status: ReduxStatus;
    error: string | null;
  };
  retractAnnouncementStatus: {
    status: ReduxStatus;
    error: string | null;
  };
  getAnnouncementStatus: {
    status: ReduxStatus;
    error: string | null;
  };
}

const initialState: DashboardState = {
  announcement: null,
  createAnnouncementStatus: {
    status: 'idle',
    error: null,
  },
  retractAnnouncementStatus: {
    status: 'idle',
    error: null,
  },
  getAnnouncementStatus: {
    status: 'idle',
    error: null,
  },
};

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(resetAll, () => initialState);
  },
});

export default dashboardSlice.reducer;
